// ==================== הקובץ המלא, השלם והמתוקן ====================

import React, { useEffect, useState, useRef } from "react";
import {
    collection,
    query,
    orderBy,
    onSnapshot,
    doc,
    deleteDoc,
    setDoc,
    updateDoc,
} from "firebase/firestore";
import { db, resetQueue, archiveOrder, resetPots } from "./firebase";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import ActiveOrders from './ActiveOrders';
// --- MUI Imports ---
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';





// --- הגדרת Theme עבור עברית (RTL) ---
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

const theme = createTheme({
  direction: 'rtl',
});
// -----------------------------------------




export default function Admin() {
    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <ActiveOrders />
                </LocalizationProvider>
            </ThemeProvider>
        </CacheProvider>
    );
}